export default __webpack_public_path__ + "static/media/4@3x.45721362.png";